import React, { useCallback, useLayoutEffect } from 'react';
import { Image, View } from 'react-native';
import Text from 'design-system/Text';
import { AppView } from 'design-system';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import hands from 'design-system/img/hands.png';
import StatusBar from 'design-system/StatusBar';
import MoneyInputField from 'design-system/MoneyInputField';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount, formatDate } from 'utils/formatting';
const strings = {
    done: 'Close',
    title: 'Payment sent',
    subTitle: 'You should see it in your account within\nthe next few hours',
};
const WithdrawDepositSuccessScreen = ({ route, navigation: { pop, setOptions }, }) => {
    const date = route.params?.date;
    const amount = route.params?.amount;
    const colors = useColors();
    const onDone = useCallback(() => {
        pop();
    }, []);
    useLayoutEffect(() => {
        setOptions({
            headerLeft: () => <NavigationCloseButton inWebHeader onPress={onDone}/>,
        });
    }, [setOptions, onDone]);
    const styles = useStyles(styleSet);
    return (<AppView paddingBottom style={styles.container}>
      <StatusBar barStyle="dark-content" animated/>
      <Spacer flex={1}/>
      <View style={styles.textContainer}>
        <Image source={hands} style={styles.fist}/>
        <Text Text-20 style={styles.title}>
          {strings.title}
        </Text>
        <Spacer h={4}/>
        <Text TextThin-14 Secondary centered style={styles.subtitle}>
          {strings.subTitle}
        </Text>
        <MoneyInputField color={colors.text.primary}>{formatAmount(amount)}</MoneyInputField>
        <Text Text-16 Secondary>
          {formatDate(date.toISOString())}
        </Text>
      </View>
      <Spacer flex={2}/>
      <Button floating brand title={strings.done} onPress={onDone}/>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        flex: 1,
    },
    btnContainer: {
        paddingHorizontal: rem(16),
    },
    textContainer: {
        alignItems: 'center',
    },
    fist: {
        height: rem(72),
        width: rem(72),
    },
    title: {
        marginTop: rem(16),
    },
    subtitle: {
        marginBottom: rem(3),
    },
}));
export default WithdrawDepositSuccessScreen;
